<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml" class="mx-5 my-4">
        <div class="pdf-item mb-3 text-center">
              <img
                src="../assets/Marley_Logo.png"
                alt="boat Logo"
                style="flex: none;"
              />
              <!-- <h3
              class="text-sm font-weight-bold text-gray-600 text-monospace"
              >
                MARLEY
                <br/>
                SHIPPING
              </h3> -->
              <!-- <h3
                class="text-sm font-weight-bold"
              >
                718-636-4813
              </h3> -->
        </div>
        <div class="pdf-item mb-3 d-flex text-sm justify-content-between font-weight-bold">
          <div>
              CONTAINER #
              <span class="mr-4"> {{ response.pickupDetails.container ?
               response.pickupDetails.container : '_____________' }} </span>
          </div>
          <div>
              INVOICE #
             <span class="mr-4"> {{ response.id ?
                response.id : '_____________' }} </span>
          </div>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <th>Shipper</th>
              <th>Consignee</th>
            </tr>
            <tr>
              <td>
                {{ response.shipper.firstName }} {{ response.shipper.lastName }}
                <br/>
                {{ response.shipper.address }}
                <br/>
                {{ response.shipper.city }},
                {{ response.shipper.country }} {{ response.shipper.zipCode }}
                <br/>
                Tel: {{ response.shipper.phone }}
              </td>
              <td>
                {{ response.consignee.firstName }} {{ response.consignee.lastName }}
                <br/>
                {{ response.consignee.address }}
                <br/>
                {{ response.consignee.city }},
                {{ response.consignee.country }} {{ response.consignee.zipCode }}
                <br/>
                Tel: {{ response.consignee.phone }}
              </td>
            </tr>
          </table>
        </div>
        <div class="pdf-item mt-4 mb-2 text-center">
          <h2 style="color:red" class="text-sm font-weight-bold text-monospace">
          YOU MUST PROVIDE US WITH A PACKING LIST FOR EACH PACKAGE YOU SEND.
          </h2>
          <h2 class="text-sm font-weight-bold text-monospace">
          BE ADVISED THAT WE ARE CURRENTLY NOT ACCEPTING SHIPMENTS CONTAINING FOOD.
          </h2>
        </div>
        <div class="pdf-item mb-2">
          <table class="table table-bordered text-sm w-100">
              <tr>
                <th>QTY</th>
                <th>PACKAGE</th>
                <th>FULL DESCRIPTION</th>
                <th>PRICE</th>
                <th>TOTAL</th>
              </tr>
              <tr v-for="item in filteredArr"
                :key="item.id">
                <th>{{ seen[item.packageType] }}</th>
                <th>{{ item.packageType }}</th>
                <th>{{ item.description }}</th>
                <th></th>
                <th></th>
              </tr>
          </table>
        </div>
        <div class="pdf-item mt-4 mb-2">
          <!-- <div class="font-weight-bold">
            I/we understand that Forward Pan American is currently NOT accepting shipments of food.
          </div>
          <div class="font-weight-bold">
          I/we understand that new merchandise is subject to Customs charges.
          </div>
          <div class="font-weight-bold">
          I/we certify that the information on this invoice is true and correct and
          that the contents of this shipment are as stated in my packing list and/or above.
          </div>
          <div class="font-weight-bold">
          I/we do hereby authorize Forward Pan American to execute any additional documents
          for the export of the merchandise described above or on my list.
          </div>
          <div class="font-weight-bold">
          I/we have read the TERMS AND CONDITIONS.
          </div> -->
          <div class="mt-4">
            <div>
              Signature
              <span class="mr-4">____________________________________</span>
              Date
              <span>____________________</span>
            </div>
          </div>
        </div>
        <!-- <div class="html2pdf__page-break" /> -->
        <!-- <div class="pdf-item mt-4 mb-2">
          <div class="text-center">
            <h3
              class="font-weight-bold"
            >
            Terms and Conditions of the Shipment Agreement
            </h3>
          </div>
          <br/>
          <ol>
            <li>
            Quotes are given on the basis of immediate acceptance of
            merchandise and are subject to the right of the withdrawal or
            revision thereafter without notice.
            </li>
            <li>
            Except where Forward Pan American Inc. (FPA) is instructed to
            and has agreed to in writing to pack the goods,
            <span class="font-weight-bold">the customer (consignor)
            warrants and accepts full responsibility that all goods have been properly
            prepared and packed</span> for shipment.
            </li>
            <li>
            The consignor hereby declares that the items listed on their
            packing list represent the entire contents of their shipment
            and acknowledges that he/she has been advised that the list will
            be used for the purpose of customs declaration.
            </li>
            <li>
            The consignor understands that failure to declare any or all
            of the contents will relieve
            <i>Forward Pan American Inc.</i>
            of any further obligation under this agreement.
            </li>
            <li>
            After all government regulations are complied with and all
            monies received, the shipment or container will be delivered
            by <i>Forward Pan American Inc.</i> to the consignee’s address, unless
            otherwise specified.
            </li>
            <li>
            <i>Forward Pan American Inc. (FPA)</i> will not accept nor deal with
            hazardous, dangerous or flammable items or goods likely to cause
            damage. Should the customer cause <i>FPA</i> to handle any such goods,
            the customer will be liable for all resulting loses and shall indemnify
            <i>FPA</i> against all claims, damages, expenses and penalties arising.
            </li>
            <li>
            Except under special arrangements previously made in writing,
            <i>Forward Pan American Inc.</i> will not accept nor deal with
            jewelry, antiques, livestock, food, plants, explosives or guns.
            </li>
            <li>
              <span class="font-weight-bold">
                <i>Forward Pan American Inc.</i> shall not be responsible for
                goods left over thirty days (30) in their warehouse or places of business.
              </span>
            </li>
            <li>
            All claims must be made at our office within seven days (7) of
            delivery of cargo and must be made in writing.
            </li>
            <li>
            <i>Forward Pan American Inc.</i> is not responsible for ny delays
            in the movement of cargo from origin to destination howsoever caused
            or any consequential loss resulting there from.
            </li>
          </ol>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'PdfTest',
  props: [
    'name',
    'response',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
    };
  },
  computed: {
    hazardous() {
      return this.response.itemDetails.items.reduce((acc, item) => acc || item.hazardous, false);
    },
    filteredArr() {
      this.reset();
      const filter = this.response.itemDetails.items.filter((el) => {
        if (el.packageType === '') {
          return false;
        }
        const duplicate = this.seen[el.packageType] !== undefined;
        if (duplicate) {
          this.seen[el.packageType] += 1;
        } else {
          this.seen[el.packageType] = 1;
        }
        return !duplicate;
      });
      return filter;
    },
  },
  methods: {
    // lower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, {});
    //   return copy;
    // },
    // arrayLower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, []);
    //   return copy;
    // },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });

      html2pdf().from(this.$refs.testHtml).set().output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
li:not(:last-child) {
    margin-bottom: 5px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }
}

</style>
